import React from 'react';
import { Shield, Clock, Award, CheckCircle2 } from 'lucide-react';

export const StatsBar = () => {
  const stats = [
    {
      icon: CheckCircle2,
      label: '100% QA Inspection',
      description: 'Every weld verified'
    },
    {
      icon: Shield,
      label: 'ISO 9001 Compliant',
      description: 'International standards'
    },
    {
      icon: Clock,
      label: '24h Response Time',
      description: 'Rapid project turnaround'
    },
    {
      icon: Award,
      label: 'Certified Welders',
      description: 'Expert craftsmanship'
    }
  ];

  return (
    <section className="py-12 bg-background-section border-y border-border-light">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="fade-in">
          <h2 className="text-center text-sm font-bold text-primary tracking-wider uppercase mb-8">
            The WeldPoint Standard
          </h2>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <div
                  key={index}
                  className="flex flex-col items-center text-center space-y-3 p-6 rounded-xl bg-background hover:shadow-soft transition-all duration-300"
                >
                  <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
                    <Icon className="w-7 h-7 text-primary" />
                  </div>
                  <h3 className="text-lg font-serif font-bold text-primary">{stat.label}</h3>
                  <p className="text-sm text-foreground-muted">{stat.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
